import React, { useEffect } from "react";
import { AboutUs, Home, OurServices } from "../screens";
import Subscription from "../screens/Subscription/Subscription";
import Whoisbehind from "../screens/Whoisbehind/Whoisbehind";
import Whoisbehind2 from "../screens/Whoisbehind2/Whoisbehind2";
import "./index.css";
import Footer from "../screens/Footer";
import homeImg from "../../assets/images/home_wave.svg";
import AOS from "aos";
import "aos/dist/aos.css";
import behindImg from "../../assets/images/yellowgradient.svg";
import Navbar from "../Navigation";

const Dashboard = () => {
  useEffect(() => {
    AOS.init({ once: true, duration: 900 });
  }, []);

  return (
    <>
      <div className="container-fluid mainConttainer1" id="Home">
        <Navbar />
        <img src={homeImg} className="bgImg1" alt="" aria-hidden="true" />
        <div className="container mainGgImg1">
          <Home />
          <AboutUs />
        </div>
      </div>

      <div className="container-fluid mainConttainer3" id="ourservices">
        <div className="bgImg3" />
        <div className="container mainGgImg3">
          <OurServices />
        </div>
      </div>

      <div className="container-fluid mainConttainer4" id="portfolio">
        <div className="container mainGgImg4">
          <Whoisbehind />
        </div>
      </div>

      <div className="container-fluid mainConttainer5">
        <img src={behindImg} className="bgImg5" alt="" aria-hidden="true" />
        <div className="container mainGgImg4">
          <Whoisbehind2 />
        </div>
      </div>

      <div className="container-fluid mainConttainer7">
        <div className="bgImg7" />
        <div className="container mainGgImg7">
          <Subscription />
        </div>
      </div>

      <div className="container-fluid mainConttainer7" id="footer">
        <div className="bgImg8" />
        <div className="container mainGgImg7">
          <Footer />
        </div>
      </div>
    </>
  );
};

export default Dashboard;
